/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * A note written in Hubble. The author is the signed-in admin, so it is not part of the body.
 * @export
 * @interface AddCarrierNoteRequest
 */
export interface AddCarrierNoteRequest {
  /**
   *
   * @type {string}
   * @memberof AddCarrierNoteRequest
   */
  carrierIdentifier: string;
  /**
   * When it happened, which is usually now but can be backdated.
   * @type {OffsetDateTime}
   * @memberof AddCarrierNoteRequest
   */
  occurredAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof AddCarrierNoteRequest
   */
  title: string;
  /**
   * Markdown.
   * @type {string}
   * @memberof AddCarrierNoteRequest
   */
  body?: string | null;
}

/**
 * Check if a given object implements the AddCarrierNoteRequest interface.
 */
export function instanceOfAddCarrierNoteRequest(
  value: object,
): value is AddCarrierNoteRequest {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("occurredAt" in value) || value["occurredAt"] === undefined)
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function AddCarrierNoteRequestFromJSON(
  json: any,
): AddCarrierNoteRequest {
  return AddCarrierNoteRequestFromJSONTyped(json, false);
}

export function AddCarrierNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddCarrierNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    occurredAt: json["occurredAt"],
    title: json["title"],
    body: json["body"] == null ? undefined : json["body"],
  };
}

export function AddCarrierNoteRequestToJSON(json: any): AddCarrierNoteRequest {
  return AddCarrierNoteRequestToJSONTyped(json, false);
}

export function AddCarrierNoteRequestToJSONTyped(
  value?: AddCarrierNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    occurredAt: value["occurredAt"],
    title: value["title"],
    body: value["body"],
  };
}
